import fetch from '@/utils/fetch';
import { SaveUserEnterConfigsParamsType, chosenShopListType } from './type';

export const getSaveUserEnterConfigs = (params: SaveUserEnterConfigsParamsType) => {
  const data = fetch<string>('/saasmerchant/web/fscompany/businessAndClient/save', {
    type: 'POST',
    useJson: true,
    params,
  });
  return data;
};

export const handleUpdateSkuPriceConfig = async (companyId: number) => {
  const data = await fetch('/saasmerchant/web/fscompany/getFlagsById', {
    params: {
      companyId,
    },
  });
  const returnData: any = {
    skuOnSaleShow: data?.skuOnSaleShow || 0,
    skuRecommendStatus: data?.skuRecommendStatus || 0,
    allowExceedSelfPay: data?.allowExceedSelfPay || 0,
    showSkuPrice: data?.showSkuPrice || 0,
  };

  return returnData;
};

export const postSaveEnterpriseEvaluationShow = async (params: {
  companyId: number;
  orderEvaluationSwitch: number;
}) => {
  return fetch<string>('/saasmerchant/web/fscompany/updateUserShowFlag', {
    type: 'POST',
    useJson: true,
    params,
  });
};

export const getSubShopListByIds = async (params: { subShopIds: number[]; companyId: number }) =>
  fetch<chosenShopListType[]>('/saasmerchant/web/fscompany/subShopListByIds', {
    type: 'POST',
    useJson: true,
    params,
  });
export const getWelfareMealLimitList = async (params: { companyId: number }) =>
  fetch<
    {
      limitId: number;
      mealType: number;
    }[]
  >('/saasmerchant/web/fscompany/welfareMealLimit/query', {
    type: 'GET',
    params,
  });
export const delWelfareMealLimit = async (params: { companyId: number; limitId: number }) =>
  fetch<boolean>('/saasmerchant/web/fscompany/welfareMealLimit/delete', {
    type: 'POST',
    useJson: true,
    params,
  });
export const saveWelfareMealLimit = async (params: { companyId: number; mealType: number }) =>
  fetch<boolean>('/saasmerchant/web/fscompany/welfareMealLimit/save', {
    type: 'POST',
    useJson: true,
    params,
  });
export const editWelfareMealLimit = async (params: {
  companyId: number;
  limitId: number;
  mealType: number;
}) =>
  fetch<boolean>('/saasmerchant/web/fscompany/welfareMealLimit/update', {
    type: 'POST',
    useJson: true,
    params,
  });
